// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"src_views_Bridge_Jitsi_vue":"41bf2885","src_views_Bridge_index_vue":"ca831564","src_views_Layout_vue":"54056916"}[chunkId] + ".js";
};